import api from 'services/api.service';

const resource = '/company-events';

export const create = (eventType) => api
  .post(`${resource}/create`, { eventType });
